import { render, staticRenderFns } from "./LayersTreeItemElement.vue?vue&type=template&id=52f753c3&scoped=true"
import script from "./LayersTreeItemElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayersTreeItemElement.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LayersTreeItemElement.vue?vue&type=style&index=0&id=52f753c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f753c3",
  null
  
)

export default component.exports